import { HarmonicQuestion } from '../../types/harmonic';

export const harmonicQuestionsTR: HarmonicQuestion[] = [
  // Seviye 1: İlgisizlik (Apathy)
  { id: 'apathy1', levelId: 1, text: 'Hedeflerimden ve isteklerimden tamamen kopuk hissettiğim çok olur', reversed: false },
  { id: 'apathy2', levelId: 1, text: 'Durumların sonucu beni ilgilendirmiyor', reversed: false },
  { id: 'apathy3', levelId: 1, text: 'Hayatımın önemli yönlerine karşı tamamen kayıtsız kaldığımı sık hissetmem', reversed: true },

  // Seviye 2: Umutsuzluk (Hopelessness)
  { id: 'hopeless1', levelId: 2, text: 'Mevcut koşullarımı değiştirmek için gücüm yetmediğini hissediyorum', reversed: false },
  { id: 'hopeless2', levelId: 2, text: 'Durumum için herhangi bir iyileşme olasılığı görmekte zorlanıyorum', reversed: false },
  { id: 'hopeless3', levelId: 2, text: 'Küçük eylemlerin tamamen anlamsız olduğuna sık inanmam', reversed: true },

  // Seviye 3: Keder (Grief)
  { id: 'grief1', levelId: 3, text: 'Kaybettiğim veya kaçırdığım şeyler hakkında çok fazla zaman harcıyorum', reversed: false },
  { id: 'grief2', levelId: 3, text: 'Geçmiş deneyimlerimi düşündüğümde derin bir üzüntü hissediyorum', reversed: false },
  { id: 'grief3', levelId: 3, text: 'Geçmiş hayal kırıklarını düşünmeye takılıp kaldığımı sık hissetmem', reversed: true },

  // Seviye 4: Korku (Fear)
  { id: 'fear1', levelId: 4, text: 'Olası olumsuz sonuçlar nedeniyle harekete geçmekte sıklıkla tereddüt ediyorum', reversed: false },
  { id: 'fear2', levelId: 4, text: 'Neyin yanlış gidebileceğini analiz etmeye önemli zaman harcıyorum', reversed: false },
  { id: 'fear3', levelId: 4, text: 'Belirsiz durumlarla başa çıkmaktan tamamen aciz hissettiğim nadirdir', reversed: true },

  // Seviye 5: Pasif Düşmanlık (Passive Hostility)
  { id: 'passive1', levelId: 5, text: 'Anlaşmazlığımı doğrudan yüzleşme yerine ince bir direniş ile ifade ediyorum', reversed: false },
  { id: 'passive2', levelId: 5, text: 'Memnuniyetsizliğimi ifade etmek için alaycı veya dolaylı yorumlar kullanıyorum', reversed: false },
  { id: 'passive3', levelId: 5, text: 'Endişelerimi doğrudan ifade etmekten sık kaçınmam', reversed: true },

  // Seviye 6: Açık Öfke (Open Anger)
  { id: 'anger1', levelId: 6, text: 'İşler beklentilerimi karşılamadığında hayal kırıklığımı doğrudan ifade ediyorum', reversed: false },
  { id: 'anger2', levelId: 6, text: 'Algılanan adaletsizliklere güçlü ve anında tepki veriyorum', reversed: false },
  { id: 'anger3', levelId: 6, text: 'Zor durumlarda hayal kırıklığının tepkilerimi tamamen kontrol etmesine nadiren izin veririm', reversed: true },

  // Seviye 7: Karşı Koyma (Antagonism)
  { id: 'antag1', levelId: 7, text: 'Başkalarının fikirlerini sıklıkla sorgulama veya meydan okuma eğilimindeyim', reversed: false },
  { id: 'antag2', levelId: 7, text: 'Plan veya önerilerdeki kusurları işaret etme eğilimindeyim', reversed: false },
  { id: 'antag3', levelId: 7, text: 'Karşı görüşleri dikkate almadan tamamen reddettiğim sık olmaz', reversed: true },

  // Seviye 8: Rasyonel Tarafsızlık (Rational Neutrality)
  { id: 'neutral1', levelId: 8, text: 'Zorluklara sakin ve mantıksal bir zihniyetle yaklaşıyorum', reversed: false },
  { id: 'neutral2', levelId: 8, text: 'Sorunları çözerken duygusal dengemi koruyabiliyorum', reversed: false },
  { id: 'neutral3', levelId: 8, text: 'Duyguların mantıksal muhakememi tamamen geçersiz kılmasına nadiren izin veririm', reversed: true },

  // Seviye 9: İlgi (Interest)
  { id: 'interest1', levelId: 9, text: 'Yeni bakış açılarını öğrenmek ve anlamak için aktif olarak çalışıyorum', reversed: false },
  { id: 'interest2', levelId: 9, text: 'Sohbetlere ve tartışmalara coşkuyla katılıyorum', reversed: false },
  { id: 'interest3', levelId: 9, text: 'Tanımadığım fikirleri dikkate almadan tamamen reddettiğim sık olmaz', reversed: true },

  // Seviye 10: İyimserlik (Optimism)
  { id: 'optimism1', levelId: 10, text: 'Zorlu durumlarda tutarlı bir şekilde fırsatları arıyorum', reversed: false },
  { id: 'optimism2', levelId: 10, text: 'Aksiliklere rağmen olumlu sonuçlara olan güvenimi koruyorum', reversed: false },
  { id: 'optimism3', levelId: 10, text: 'Engellerle karşılaştığımda tamamen umut göremediğim durumlar nadirdir', reversed: true },

  // Seviye 11: Coşku (Enthusiasm)
  { id: 'enthus1', levelId: 11, text: 'Fikirleri paylaşırken ve başkalarıyla iş birliği yaparken enerjik hissediyorum', reversed: false },
  { id: 'enthus2', levelId: 11, text: 'Tutkum ve heyecanım ile başkalarına ilham veriyorum', reversed: false },
  { id: 'enthus3', levelId: 11, text: 'Bir zamanlar ilgimi çeken projeler için tüm hevesimi kaybettiğim nadirdir', reversed: true },

  // Seviye 12: Coşkunluk (Exhilaration)
  { id: 'exhil1', levelId: 12, text: 'Aktivitelerimde saf mutluluk ve uyum anları yaşıyorum', reversed: false },
  { id: 'exhil2', levelId: 12, text: 'Derin bir tatmin ve amaç duygusu hissediyorum', reversed: false },
  { id: 'exhil3', levelId: 12, text: 'Günlük deneyimlerimde tamamen mutluluk bulamadığım sık olmaz', reversed: true }
];
